module.exports = __webpack_public_path__ + "static/img/1-1Z5241KH1357.b26c271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5241KH1357.jpg
// module id = R6Xi
// module chunks = 0